module.exports = __webpack_public_path__ + "img/22.87ed773c.jpg";